export default "__VITE_ASSET__CgA_NGMq__"